module.exports = __webpack_public_path__ + "img/Resalat.2ba7e3b5.svg";